export default __webpack_public_path__ + "static/media/ease-of-access.49e8ebec.png";